import { createContext, useContext, useMemo, useState, type PropsWithChildren } from "react";
import { tokenStore } from "./tokenStore";

interface AuthContextType {
  token: string;
  email: string;
  isAuthenticated: boolean;
  setSession: (token: string, email: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: PropsWithChildren) {
  const [token, setToken] = useState(() => tokenStore.getToken());
  const [email, setEmail] = useState(() => tokenStore.getEmail());

  const value = useMemo<AuthContextType>(
    () => ({
      token,
      email,
      isAuthenticated: token.length > 0,
      setSession(nextToken: string, nextEmail: string) {
        tokenStore.setToken(nextToken);
        tokenStore.setEmail(nextEmail);
        setToken(nextToken);
        setEmail(nextEmail);
      },
      logout() {
        tokenStore.clear();
        setToken("");
        setEmail("");
      }
    }),
    [token, email]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
}
